import React, { useState } from 'react'
import getImages from '../data/wyrmprints_import'
import { FormattedMessage } from 'react-intl'
import { avalibility } from '../data/convert'
import en from '../locale/en_wyrmprints'

function MainItem(props) {
  const images = getImages(props.value.id)
  const [src, setSrc] = useState(images[0])
  const [mouseOver, setMouseOver] = useState(false)

  const type = props.value.type
  let classType = 'main-item'
  switch(type) {
    case 1: 
      classType += ' main-item-seasonal'
      break
    case 2: 
      classType += ' main-item-event'
      break
    case 3: 
      classType += ' main-item-collab'
      break
    case 4: 
      classType += ' main-item-promo'
      break
    default:
      break
  }

  const url = 'https://dragalialost.gamepedia.com/' + en[props.value.id].replace(' ', '_')

  return (
    <a className={classType} href={url} target='_blank' rel='noopener noreferrer'
      onMouseEnter={() => {
        setSrc(images[1])
        setMouseOver(true)
      }}
      onMouseLeave={() => {
        setSrc(images[0])
        setMouseOver(false)
      }}
    >
      <div className='main-image-div'>
        <img className='main-image' src={src} alt={props.value.name}></img>
        <div className='main-id'>
        { mouseOver &&
          props.value.id
        }
        </div>
      </div>
      <div className='main-content'>
        <div className='main-text'><b><FormattedMessage id={props.value.id}/></b></div>
        {
          props.value.abilities.map(item => {
            return concatAbility(item, props.isEn)
          })
        }
      </div>
      <div className='main-content-right'>
        <div className='main-text' style={{float: 'right', color: avalibility[type].color}}>
        { (mouseOver && type > 0) &&
          <AvalibilityItem id={avalibility[type].type} isEn={props.isEn}/>
        }
        </div>
        <div>
        {
          props.value.abilities.map(item => {
            return concatMaxValue(item, props.isEn)
          })
        }
        </div>
      </div>
    </a>
  );
}

function AvalibilityItem(props) {
  return (
    <div>
      {'<'}
      <FormattedMessage id={props.id}/>
      {'>'}
    </div>
  )
}

function concatAbility(item, isEn) {
  const isInt = Number.isInteger(item.value)
  let str_1 = isEn ? '\n' : ''
 
  if (item.effect.substring(0, 3) !== 'exp') {
    if (isInt)
      str_1 += '+'
    str_1 += item.value
    if (isInt)
      str_1 += '%'
  }

  return (
    <div className='main-text' key={item.effect+item.value} style={{clear: 'both'}}>
      { item.effect.match(/hts.*/) && 
        item.value
      }
      { item.exclusive !== '' &&
        <FormattedMessage id={item.exclusive}/>
      }
      <FormattedMessage id={item.effect}/>
      { !item.effect.match(/hts.*/) && 
        str_1
      }
    </div>
  )
}

function concatMaxValue(item, isEn) {
  const isInt = Number.isInteger(item.value)
  let str_2 = ''
  if (item.effect.substring(0, 3) !== 'hts') {
    str_2 += '(Max '
    str_2 += item.maxValue
    if (isInt)
      str_2 += '%'
    else if (item.effect === 'afl_grd')
      str_2 += isEn ? ' times' : '次'
    str_2 += ')'
  }
  return (
    <div className='main-text'
         style={{float: 'right', clear: 'right'}}
         key={item.effect+item.value}
    >
      {str_2}
    </div>
  )
}

export default MainItem